import React, { useState, useEffect, createContext } from "react";

export const MapContext = createContext();

export const MapProvider = ({ children }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showAccount, setShowAccount] = useState(false);
  const [userLongitude, setUserLongitude] = useState(18.6543407);
  const [userLatitude, setUserLatitude] = useState(54.3567841);
  const [userLocationAvailable, setUserLocationAvailable] = useState(false);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLatitude(position.coords.latitude);
          setUserLongitude(position.coords.longitude);
          setUserLocationAvailable(true);
        },
        (error) => {
          console.log(error.message);
          setUserLocationAvailable(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      console.log("Geolocation is not available");
    }
  }, []);

  useEffect(() => {
    let permissionStatus;

    const checkPermission = async () => {
      if (!navigator.permissions) return;

      try {
        permissionStatus = await navigator.permissions.query({
          name: "geolocation",
        });

        if (permissionStatus.state === "granted") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setUserLatitude(position.coords.latitude);
              setUserLongitude(position.coords.longitude);
              setUserLocationAvailable(true);
            },
            () => setUserLocationAvailable(false)
          );
        }

        permissionStatus.onchange = () => {
          if (permissionStatus.state === "granted") {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                setUserLatitude(position.coords.latitude);
                setUserLongitude(position.coords.longitude);
                setUserLocationAvailable(true);
              },
              () => setUserLocationAvailable(false)
            );
          } else {
            setUserLocationAvailable(false);
          }
        };
      } catch (err) {
        console.error("Permissions API error:", err);
      }
    };

    checkPermission();

    return () => {
      if (permissionStatus) {
        permissionStatus.onchange = null; // Clean up listener
      }
    };
  }, []);

  return (
    <MapContext.Provider
      value={{
        showDetails,
        setShowDetails,
        details,
        setDetails,
        searchText,
        setSearchText,
        showAccount,
        setShowAccount,
        userLongitude,
        setUserLongitude,
        userLatitude,
        setUserLatitude,
        userLocationAvailable,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
